var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarryOnHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29388",
    "data-name": "Group 29388",
    transform: "translate(-422 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(422 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_8_",
    "data-name": "svgexport-17 (8)",
    transform: "translate(442 270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49879",
    "data-name": "Path 49879",
    d: "M345.031,121.519a.408.408,0,0,1-.408-.408v-3.325h-3.916v3.325a.408.408,0,1,1-.817,0v-3.733a.408.408,0,0,1,.408-.408h4.733a.408.408,0,0,1,.408.408v3.733a.408.408,0,0,1-.408.408Zm0,0",
    transform: "translate(-336.489 -116.969)",
    fill: "#ffe785"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28910",
    "data-name": "Group 28910",
    transform: "translate(2.19 18.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49880",
    "data-name": "Path 49880",
    d: "M317.348,468.755a.762.762,0,0,1-.762-.762v-1.579h1.524v1.579A.762.762,0,0,1,317.348,468.755Zm6.449,0a.762.762,0,0,1-.762-.762v-1.579h1.524v1.579A.762.762,0,0,1,323.8,468.755Z",
    transform: "translate(-316.586 -466.414)",
    fill: "#1a414c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49885",
    "data-name": "Path 49885",
    d: "M286.838,188.322v11.015a2.19,2.19,0,0,1-2.19,2.189h-7.973a2.19,2.19,0,0,1-2.189-2.189V188.322a2.19,2.19,0,0,1,2.189-2.189h7.973a2.19,2.19,0,0,1,2.19,2.189Zm0,0",
    transform: "translate(-274.485 -182.536)",
    fill: "#ce1b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49886",
    "data-name": "Path 49886",
    d: "M314.915,188.322v11.015a2.19,2.19,0,0,1-2.19,2.189h-6.432a2.19,2.19,0,0,1-2.19-2.189V188.322a2.19,2.19,0,0,1,2.19-2.189h6.432a2.19,2.19,0,0,1,2.19,2.189Zm0,0",
    transform: "translate(-302.563 -182.536)",
    fill: "#f45395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49887",
    "data-name": "Path 49887",
    d: "M331.56,117.786h-6.3a.408.408,0,1,1,0-.817h6.3a.408.408,0,1,1,0,.817Zm0,0",
    transform: "translate(-322.235 -116.969)",
    fill: "#1a414c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49888",
    "data-name": "Path 49888",
    d: "M320.138,231.444a.626.626,0,0,1-.626-.626V220.15a.626.626,0,1,1,1.252,0v10.668a.626.626,0,0,1-.626.626Zm3.208,0a.626.626,0,0,1-.626-.626V220.15a.626.626,0,0,1,1.253,0v10.668a.626.626,0,0,1-.626.626Zm3.208,0a.626.626,0,0,1-.626-.626V220.15a.626.626,0,0,1,1.252,0v10.668a.626.626,0,0,1-.626.626Zm0,0",
    transform: "translate(-317.17 -214.19)",
    fill: "#ce1b6d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarryOnHighlighted);
export default __webpack_public_path__ + "static/media/CarryOnHighlighted.ce60241c54f871be4283afc04506c112.svg";
export { ForwardRef as ReactComponent };